document.addEventListener("DOMContentLoaded", function(event) {

    // fixed header
    window.addEventListener("scroll", (e) => {
        var scrolled = document.scrollingElement.scrollTop;

        if(scrolled > 0){
            document.querySelector('.hlavicka').classList.add('fixed');
        } else {
            document.querySelector('.hlavicka').classList.remove("fixed");
        }
    });

    let dataloadjselement = document.querySelector('[data-load-js-element]');
    if(dataloadjselement !== null){
        dataloadjselement.style.display = 'block';
    }


});

/*$(window).scroll(function(){
    var headerHeight = $(".hlavicka").innerHeight();
    var scroll = $(window).scrollTop();

    if(scroll > 0) {
        $(".hlavicka").addClass("fixed");
    }
    else {
        $(".hlavicka").removeClass("fixed");
    }
})

$(document).ready(function(){
    if($('[data-load-js-element]').length) {
        $('[data-load-js-element]').show();
    }
});
;
window.SumoSelect = function () {
}
*/
// swiper detail nemovitosti - náhledy pod fotografií
/*
const photoSlider = () => {
    if ($('.JS-nemovitosti-photo-slider').length > 0) {
        var galleryTop = new Swiper('.JS-nemovitosti-photo-slider', {
            spaceBetween: 10,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            slidesPerView: 1,
            breakpoints: {
                480: {
                    slidesPerView: 2,
                    spaceBetween: 20
                },
                800: {
                    slidesPerView: 3,
                    spaceBetween: 10
                }
            }
        });
    }
};

window.funcAfterListRender = window.nemovitostiOwlCarusel = photoSlider;

$(document).ready(function () {
    photoSlider();
});*/
